import { render } from "./ConnectedAccounts.vue?vue&type=template&id=d971fdb6"
import script from "./ConnectedAccounts.vue?vue&type=script&lang=js"
export * from "./ConnectedAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__